import { useEffect, useState } from 'react';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import { fetchMFAPreference } from 'aws-amplify/auth';
import { Card, Badge } from '../../design-system';
import styles from './account.module.css';

/**
 * Two-factor section of the My Account page. Read-only status for now: our pool
 * keeps MFA REQUIRED (passkey Design B), so users always have TOTP. Self-service
 * re-registration of a new device needs a client-side QR render (a new dependency
 * pending architect review) and is tracked separately — Trello VUz4tslL.
 */
export default function TwoFactorCard() {
  const [status, setStatus] = useState('loading'); // loading | enabled | disabled | error

  useEffect(() => {
    let active = true;
    fetchMFAPreference()
      .then((pref) => {
        if (!active) return;
        setStatus((pref.enabled || []).includes('TOTP') ? 'enabled' : 'disabled');
      })
      .catch(() => {
        if (active) setStatus('error');
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <Card padding="lg">
      <div className={styles.cardHead}>
        <ShieldOutlinedIcon className={styles.cardIcon} aria-hidden="true" />
        <div className={styles.cardHeadText}>
          <div className={styles.cardTitle}>Two-factor authentication</div>
          <div className={styles.cardDesc}>
            An authenticator app generates a one-time code when you sign in with a password.
          </div>
        </div>
      </div>
      <div className={styles.statusRow}>
        <span className={styles.rowLabel}>Authenticator app</span>
        {status === 'loading' && <span className={styles.muted}>Checking&hellip;</span>}
        {status === 'enabled' && <Badge variant="success">Enabled</Badge>}
        {status === 'disabled' && <Badge variant="warning">Not set up</Badge>}
        {status === 'error' && <span className={styles.muted}>Status unavailable</span>}
      </div>
      <div className={styles.mutedNote}>Setting up a new device is coming soon.</div>
    </Card>
  );
}
